import HttpError from './HttpError';

class HttpNotFoundError extends HttpError {
  constructor(message) {
    super(message, 404);
  }
}

export default HttpNotFoundError;
